<template>
  <div class="vip-card" v-if="userStore.vipAvailable">
    <van-row style="display: flex; align-items: center;">
      <van-col class="initRow" span="6">
        <img src="@/assets/themeThree/level_one.png">
      </van-col>
      <van-col span="17">
        <span>{{ $t('vip.follow') }} <span style="color: goldenrod;">VIP{{ currentLevel }}</span> {{ $t('vip.needToBet') }} {{ betMin
        }}</span>
      </van-col>
      <van-col span="1" @click="onClickCard">
        <van-icon name="arrow" size="20" />
      </van-col>
    </van-row>

    <div class="vip-body">
      <div class="vip-section">
        <van-row>
          <van-col :span="6">
            <span>{{ $t('vip.betRequired') }}</span>
          </van-col>
          <van-col :span="18">
            <div class="bar">
              <span style="position: absolute;left: 35%;top: 6%;">
                {{ betMin + '/' + betTotal }}
              </span>
              <div class="progress"
                :style="{ width: betTotal / betMin < 1 ? (betTotal * 100) / betMin + '%' : '100%' }">
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { clickOnCard } from '@/view/profile/supportScript'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const userStore = useUserStore()
const isPopping = ref(false)

const currentLevel = computed(() => userStore.VIPData.currentLevel)
const betTotal = computed(() => userStore.VIPData.cumulativeBetTotal)
const betMin = computed(() => userStore.VIPData.bet_min)
const nextLevel = computed(() => userStore.VIPData.nextLevel)

const onClickCard = () => clickOnCard(router, isPopping, '/sd-vip')
</script>

<style scoped>
.vip-card {
  /* width: 100%; */
  /* margin: 10px; */
  border-radius: 10px;
  background: #161d30;
  overflow: hidden;
  color: #fff;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: transform 0.2s ease;
  padding: 10px;
}


.initRow img {
  width: 100%;
}



/* Header gradient */
/* .vip-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: linear-gradient(90deg, #c854ad 0%, #432e4f 100%);
  color: #fff;
}

.vip-title {
  padding: 8px;
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffc809;
  background: linear-gradient(180deg, #7a3cff 0%, #F46EC2 100%);
}

.vip-title span {
  font-size: 30px;
  padding-left: 5px;
}

.vip-link {
  padding: 11px;
  font-size: 13px;
  opacity: 0.9;
  display: flex;
  background-color: #441579;
  justify-content: flex-end;
  align-items: center;
  color: #FFFFFFA6;
} */

/* Body */
/* .vip-body {
  padding: 22px 15px 4px 15px;
  ;
  background: #3e2e4b;
}

.vip-section {
  margin-bottom: 16px;
}

.vip-label {
  color: #ffa4d1;
  font-size: 13px; */
/* margin-bottom: 4px; */
/* } */

.vip-values {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #FFF;
  margin-bottom: 5px;
}

.vip-values-bottom {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #fe0;
  margin-top: 5px;
}

/* Progress bars */
.bar {
  position: relative;
  background: #3b4152;
  border-radius: 20px;
  height: 15px;
  margin-top: 5px;
  overflow: hidden;
}

.progress {
  background: #a86ce6;
  height: 100%;
  border-radius: 20px;
  transition: width 0.4s ease;
}

.progress.yellow {
  background: #f8d74a;
}

/* Animation */
.pop-animate {
  animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
  }
}
</style>
